import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { PropertyCategoryIdentifierAdapter } from 'common/data/property-category/identifier/adapter';
import { configGetSettings } from 'common/helper/config/get-settings';
import { PreactView } from 'common/module/preact/view';
import { FormPropertyReportTemplate } from 'common/module/property-report/template';
import { FormPropertyReportViewStoreFactory } from 'common/module/property-report/view-store.factory';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

import { PropertyReportSettingsFormInterface } from '../settings-form.interface';
import { PropertyReportButtonViewStore } from './view-store';

export function PropertyReportButtonViewStoreFactory(): PropertyReportButtonViewStore {
  return new PropertyReportButtonViewStore(
    EventEmitterFactory(),
    configGetSettings<PropertyReportSettingsFormInterface>(),
    new PreactView(FormPropertyReportTemplate, FormPropertyReportViewStoreFactory()),
    StatsTealiumProviderService(),
    UserAuthenticationService(),
    new PropertyCategoryIdentifierAdapter()
  );
}
